var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoNotification(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 160,
    viewBox: "0 0 119 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.11 76.1299C16.6512 76.1299 17.09 75.6912 17.09 75.1499C17.09 74.6087 16.6512 74.1699 16.11 74.1699C15.5688 74.1699 15.13 74.6087 15.13 75.1499C15.13 75.6912 15.5688 76.1299 16.11 76.1299Z",
    fill: "#CFCFCF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M79.66 35.1698C71.29 35.1698 62.7699 34.8298 54.7999 32.6098C46.9799 30.4398 39.7999 26.2298 33.3999 21.3598C29.2099 18.1898 25.3999 15.6598 19.9599 16.0398C14.638 16.3278 9.54874 18.3151 5.43995 21.7098C-1.48005 27.7698 -0.440053 38.9998 2.32995 46.8598C6.48995 58.7298 19.1499 66.9998 29.9099 72.3498C42.3399 78.5598 55.9999 82.1698 69.6899 84.2398C81.6899 86.0698 97.1099 87.3898 107.51 79.5598C117.06 72.3498 119.68 55.9098 117.34 44.8098C116.772 41.5307 115.026 38.5719 112.43 36.4898C105.72 31.5798 95.7099 34.8598 88.1699 35.0198C85.3699 35.0798 82.52 35.1498 79.66 35.1698Z",
    fill: "#F2F2F2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2299 85.4804C68.4652 85.4804 73.5199 80.4257 73.5199 74.1904C73.5199 67.9551 68.4652 62.9004 62.2299 62.9004C55.9946 62.9004 50.9399 67.9551 50.9399 74.1904C50.9399 80.4257 55.9946 85.4804 62.2299 85.4804Z",
    fill: "#D2D2D2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5636 3.70535C51.1878 3.56617 51.8333 3.55129 52.4632 3.66158C53.0932 3.77186 53.6953 4.00515 54.2351 4.34811C54.7749 4.69107 55.2418 5.137 55.6093 5.66043C55.9768 6.18386 56.2375 6.77454 56.3767 7.39875L58.1809 15.49L48.6548 17.6141L46.8506 9.52284C46.7111 8.89699 46.6965 8.24973 46.8077 7.61823C46.9189 6.98673 47.1538 6.3834 47.4988 5.84289C47.8437 5.30237 48.2921 4.8353 48.818 4.46848C49.3439 4.10167 49.9371 3.84233 50.5636 3.70535Z",
    fill: "white",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M95.07 67.1801L37.18 80.0801C36.8204 80.1608 36.446 80.1464 36.0937 80.0382C35.7414 79.9301 35.4234 79.732 35.171 79.4634C34.9186 79.1949 34.7406 78.8652 34.6545 78.5069C34.5684 78.1486 34.5772 77.774 34.68 77.4201L34.92 76.5901C36.92 69.5001 38.66 61.6901 37.06 54.4901L33.64 39.1301C30.76 26.2201 38.5 13.0701 51.34 9.90011C54.471 9.12285 57.7258 8.9797 60.913 9.47911C64.1001 9.97852 67.1551 11.1104 69.8983 12.8081C72.6415 14.5058 75.0174 16.7351 76.8862 19.3647C78.7549 21.9943 80.0788 24.9712 80.78 28.1201L84.31 44.0001C85.92 51.2001 90.78 57.5601 95.64 63.1001L96.21 63.7501C96.4408 64.0285 96.5969 64.361 96.6636 64.7164C96.7304 65.0717 96.7056 65.4382 96.5915 65.7814C96.4775 66.1245 96.278 66.4329 96.0118 66.6776C95.7456 66.9224 95.4215 67.0953 95.07 67.1801Z",
    fill: "white",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M74.57 2.20024C75.1112 2.20024 75.55 1.76147 75.55 1.22023C75.55 0.678995 75.1112 0.240234 74.57 0.240234C74.0287 0.240234 73.59 0.678995 73.59 1.22023C73.59 1.76147 74.0287 2.20024 74.57 2.20024Z",
    fill: "#CFCFCF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.11 76.1299C16.6512 76.1299 17.09 75.6912 17.09 75.1499C17.09 74.6087 16.6512 74.1699 16.11 74.1699C15.5688 74.1699 15.13 74.6087 15.13 75.1499C15.13 75.6912 15.5688 76.1299 16.11 76.1299Z",
    fill: "#CFCFCF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M101.65 24.8906V29.1906",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5 27.0391H103.8",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M103.61 89.6309V93.9309",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M101.46 91.7793H105.76",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4301 8.58984V12.8898",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M26.28 10.7402H30.58",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M59.58 103.699C79.8544 103.699 96.29 102.674 96.29 101.409C96.29 100.144 79.8544 99.1191 59.58 99.1191C39.3056 99.1191 22.87 100.144 22.87 101.409C22.87 102.674 39.3056 103.699 59.58 103.699Z",
    fill: "#F2F2F2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M94.6499 22.4499C94.6473 25.4912 93.438 28.4071 91.2875 30.5575C89.1371 32.708 86.2212 33.9173 83.1799 33.9199C82.8058 33.9199 82.4319 33.8999 82.0599 33.8599L78.6599 39.4099L77.5999 32.4599C75.8335 31.4763 74.3584 30.0433 73.3242 28.306C72.2899 26.5686 71.7333 24.5888 71.7107 22.5671C71.6881 20.5453 72.2002 18.5536 73.1954 16.7935C74.1905 15.0335 75.6331 13.5678 77.3771 12.5449C79.1211 11.522 81.1046 10.9783 83.1264 10.9689C85.1482 10.9594 87.1366 11.4846 88.8901 12.4911C90.6436 13.4977 92.0999 14.9499 93.1114 16.7005C94.1229 18.4512 94.6537 20.4381 94.6499 22.4599V22.4499Z",
    fill: "white",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M78.28 23.6091C78.9206 23.6091 79.44 23.0897 79.44 22.4491C79.44 21.8084 78.9206 21.2891 78.28 21.2891C77.6393 21.2891 77.12 21.8084 77.12 22.4491C77.12 23.0897 77.6393 23.6091 78.28 23.6091Z",
    fill: "#D2D2D2",
    stroke: "#D2D2D2",
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M83.18 23.6091C83.8207 23.6091 84.34 23.0897 84.34 22.4491C84.34 21.8084 83.8207 21.2891 83.18 21.2891C82.5394 21.2891 82.02 21.8084 82.02 22.4491C82.02 23.0897 82.5394 23.6091 83.18 23.6091Z",
    fill: "#D2D2D2",
    stroke: "#D2D2D2",
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M88.08 23.6091C88.7207 23.6091 89.24 23.0897 89.24 22.4491C89.24 21.8084 88.7207 21.2891 88.08 21.2891C87.4394 21.2891 86.92 21.8084 86.92 22.4491C86.92 23.0897 87.4394 23.6091 88.08 23.6091Z",
    fill: "#D2D2D2",
    stroke: "#D2D2D2",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoNotification);
export default __webpack_public_path__ + "static/media/NoNotification.dced13c586268483f7bc317ca757fa18.svg";
export { ForwardRef as ReactComponent };